import { makeAutoObservable } from 'mobx';
import apiConfig from '../api/routes';
import { LeaveTypesI, LeaveRequestPrerequisites, VacationTypesIds } from '../types';


class LeaveTypesList {
  leaveTypesList: LeaveTypesI[] = [];
  leaveTypesById: LeaveTypesI[] = [];
  allLeaveTypes : LeaveTypesI[] = [];
  areAllLeaveTypesFetched = false;
  isFetchedLeaveTypes = false;
  prerequisites: LeaveRequestPrerequisites = {
    requestTypes: [],
    availableDays: {
      available: -1,
      transfer: -1,
    },
    leaveRequestCreationCalendarAccessDto: {
      availableStartDate: null,
      availableEndDate: null,
    },
  };
  vacationTypesIds: VacationTypesIds = {
    vacation: 0,
    vacationOnDemand: 0,
  };
  constructor() {
    makeAutoObservable(this);
  }

  getAllLeaveTypes = async () => {
    try {
      this.areAllLeaveTypesFetched = false;
      this.allLeaveTypes = await apiConfig.leaveTypesService.getAllLeaveTypes();
      this.allLeaveTypes.sort((a, b) => (a.requestName <= b.requestName) ? -1 : 1);
      this.areAllLeaveTypesFetched = true;
    }
    catch (e) {
      this.areAllLeaveTypesFetched = false;
    }
  };
  getLeaveTypesByRequestId = async (id: number | string) => {
    this.leaveTypesById = await apiConfig.leaveTypesService.getLeaveTypesByRequestId(id);
    return  await apiConfig.leaveTypesService.getLeaveTypesByRequestId(id);
  };

  getLeaveTypesList = async (userId?: number | string) => {
    try{
      this.isFetchedLeaveTypes = false;
      this.leaveTypesList = await apiConfig.leaveTypesService.getLeaveTypes(userId);
      this.isFetchedLeaveTypes = true;
    }
    catch (e) {
      this.isFetchedLeaveTypes = false;
    }
  };

  getLeaveRequestPrerequisites = async (userId?: number, date?: Date) => {
    this.prerequisites = await apiConfig.leaveTypesService.getLeavePrerequisites(userId, date);
  };
}

export const LeaveTypesStore = new LeaveTypesList();
